import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";



export var activateNewTutorForCourses = function(email, courses, instanceId, list, btn, reload=true, modalId='activate-new-tutor'){

    const url = '/instance/' + instanceId.toString() + '/tutor/invite'

    const data = {
        email: email,
        courses: courses
    }

    const success = function (data){
        successToast("Tutor/-in mit der Mail " + email + "wurden der/die Kurs/-e angeboten", "Erfolg", 12500, true);
    }

    return ajaxRequest(url, success, data, btn)
  }